import script from "./FilterCriteriaCategory.vue?vue&type=script&setup=true&lang=js"
export * from "./FilterCriteriaCategory.vue?vue&type=script&setup=true&lang=js"

import "./FilterCriteriaCategory.vue?vue&type=style&index=0&id=7b0447ec&scoped=true&lang=scss"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7b0447ec"]])

export default __exports__